import { render, staticRenderFns } from "./FanIcon.vue?vue&type=template&id=4bc670bc&scoped=true"
import script from "./FanIcon.vue?vue&type=script&lang=js"
export * from "./FanIcon.vue?vue&type=script&lang=js"
import style0 from "./FanIcon.vue?vue&type=style&index=0&id=4bc670bc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc670bc",
  null
  
)

export default component.exports